import { default as Image, default as ImageN } from 'next/image'
import Link from 'next/link'

import { Doctor } from '@/lib/types'
import { cn } from '@/lib/utils'

import { PrimaryButton } from '../Buttons'
import DateWrapper from '../ui/date-wrapper'

const DoctorProfile = ({
  doctorPhoto,
  doctorName,
  // clinicName,
  specialization,
  experience,
  nextSlot,
  buttonLabel,
  buttonRoute,
  followUpFee,
  buttonClass,
}: Doctor & {
  buttonClass?: string
}) => {
  return (
    <div className='md:w-[350px] rounded-2xl bg-[#EEF0F0] overflow-hidden shadow'>

      <div className='relative w-full h-[310px]'>
        <Image
          className='object-cover'
          src={doctorPhoto}
          alt='doctor-image'
          fill
          priority
        />
        {/* EXPERIENCE BADGE */}
        <div className='absolute top-7 right-0 bg-[#F59405] text-white text-xs px-3 py-1 rounded-l-md font-light md:w-1/4 w-1/3'>
          {experience} Years Of Experience
        </div>
      </div>

      <div className='px-7 py-5'>
        <div className='flex justify-between items-center'>
          <span className='flex flex-col gap-1.5'>
            <h4 className='text-sm font-semibold'>{doctorName}</h4>
            <p className='text-xs font-light '>{specialization || "-"}</p>
          </span>

          <div className='flex items-center gap-3 bg-white px-2 py-1 rounded-full text-sm'>
            
            <Image
              className='object-contain w-4 h-4'
              src="/icons/star.png"
              alt='rating'
              height={16}
              width={16}
              

            />
            <span>{nextSlot ? '4.5' : '-'}</span>
          </div>
        </div>
        {/* <p className='text-sm font-normal text-[#252234]'>{clinicName}</p> */}

      </div>


      <div className='px-7 pt-9 pb-7'>
        <div className='mb-2 flex gap-2 items-center pb-3'>
          <ImageN src='/icons/Calendar.png' alt='calender' width={30} height={30} />
          <p>
            {nextSlot ? (
              <div className='flex flex-col'>
                <p className='font-semibold text-xs text-black'>
                  Next Availability
                </p>
                <DateWrapper formatStr='dd-MM-yyyy | hh:mm a' className='font-normal text-xs'>{nextSlot}</DateWrapper>
              </div>
            ) : (
              <p className='font-semibold text-xs text-black'>
                No slots available
              </p>

            )}
          </p>
        </div>
        {followUpFee && (
          <span
            className={`
              flex flex-row justify-between gap-3 p-1 text-sm font-bold
            `}
          >
            <p>Follow up fee </p>
            <p>{followUpFee}</p>
          </span>
        )}
        <Link href={buttonRoute || '#'}>
          <PrimaryButton
            className={cn(
              `
                h-12 w-full rounded bg-orange-500 text-white opacity-90 transition-opacity
                duration-300

                hover:opacity-100
              `,
              buttonClass
            )}
          >
            {buttonLabel}
          </PrimaryButton>
        </Link>
      </div>
    </div>
  )
}

export default DoctorProfile
